import { render, staticRenderFns } from "./baseprolineAction.vue?vue&type=template&id=79c5fdd8&scoped=true"
import script from "./baseprolineAction.vue?vue&type=script&lang=js"
export * from "./baseprolineAction.vue?vue&type=script&lang=js"
import style0 from "./baseprolineAction.vue?vue&type=style&index=0&id=79c5fdd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c5fdd8",
  null
  
)

export default component.exports